import { BreachPathAppWebComponent } from './component/BreachPathAppWebComponent';
import { WEB_COMPONENT_BREACH_PATH_APP } from '../../webcomponents.constants';

export { BreachPathAppWebComponent };

window.customElements.define(WEB_COMPONENT_BREACH_PATH_APP, BreachPathAppWebComponent);
